exports = module.exports = require("../../../NodeModules/Ljbc/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.CheckboxList span {\n    cursor: default;\n}\n", ""]);

// exports
